module.exports = __webpack_public_path__ + "static/3-8774e17d2b6ba2d81e5dbc059cd9f051.jpg";